
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/seedance-2-0",
      function () {
        return require("private-next-pages/models/seedance-2-0.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/models/seedance-2-0"])
      });
    }
  